export default "__VITE_ASSET__D3erh6i5__"